@if (data$ | async; as component) {
  <div class="container brands" [style]="'background-color :'+ component.background">
    @if (component.title) {
      @switch (component.titleTag) {
        @case ('H1') {
          <h1
            class="h2-component"
            [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
            >
            {{component.title}}
          </h1>
        }
        @case ('H2') {
          <h2
            class="h2-component"
            [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
            >
            {{component.title}}
          </h2>
        }
        @default {
          <div
            class="h2-component"
            [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
            >
            {{component.title}}
          </div>
        }
      }
    }
    @if ((isMobile() | async)) {
      <cx-carousel
        [items]="items$ | async "
        [template]="ourBrands"
        itemWidth="75%"
        [hideIndicators]="true"
        [hideButtons]="false"
        [animation]="animation"
        >
      </cx-carousel>
    } @else {
      <cx-carousel
        [items]="items$ | async "
        [template]="ourBrands"
        itemWidth="25%"
        [hideIndicators]="true"
        [hideButtons]="false"
        [animation]="animation"
        >
      </cx-carousel>
    }
  </div>
}


<ng-template #ourBrands let-item="item">
  @if (item.urlLink) {
    <a [routerLink]="item.urlLink?.url">
      <cx-media [container]="item.image"></cx-media>
      @switch (item.titleTag) {
        @case ('H1') {
          <h1 class="h1-component"> {{item.title}}</h1>
        }
        @case ('H2') {
          <h2 class="h1-component"> {{item.title}}</h2>
        }
        @default {
          <div class="h1-component"> {{item.title}}</div>
        }
      }
      <span class="description-brand"> {{item.description}}</span>
    </a>
  } @else {
    <a href="javascript:;">
      <cx-media [container]="item.image"></cx-media>
      @switch (item.titleTag) {
        @case ('H1') {
          <h1 class="h1-component"> {{item.title}}</h1>
        }
        @case ('H2') {
          <h2 class="h1-component"> {{item.title}}</h2>
        }
        @default {
          <div class="h1-component"> {{item.title}}</div>
        }
      }
      <span class="description-brand"> {{item.description}}</span>
    </a>
  }
</ng-template>
